module.exports = __webpack_public_path__ + "img/police_station_thumbnail.5372a7d3.jpg";